import {
  Box,
  Card,
  Stack,
  useMediaQuery,
  useTheme,
} from '@ltvco/refresh-lib/theme';
import { useEffect } from 'react';

import { searchpal } from 'images';

import { DotsLoading } from './components/DotsLoading';
import { SearchpalChatMessage } from './SearchpalChatMessage';
import { SearchpalChatbotProps } from './types';

export function SearchpalChatbot({
  expandContent,
  messages,
  isGeneratingResponse,
  messagesEndRef,
  applyPendingFilters,
  setChatbotOpen,
  isDrawer,
}: SearchpalChatbotProps & { resultsCount?: number }) {
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
  useEffect(() => {
    if ((messagesEndRef && messagesEndRef.current) || isGeneratingResponse) {
      messagesEndRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }, [messages, messagesEndRef, isGeneratingResponse]);

  return (
    <Box
      sx={{
        height: isDesktop && isDrawer ? '97%' : '100%',
        display: 'flex',
        flexDirection: 'column',
        '@media (max-height:600px)': {
          maxHeight: '50vh',
        },
      }}
    >
      <Stack
        direction="column"
        sx={(theme) => ({
          flexGrow: 1,
          overflowY: 'auto',
          padding: theme.spacing(2),
          minHeight: 0,
        })}
      >
        {messages.map((message, idx) => (
          <SearchpalChatMessage
            key={`${message.timestamp}-${idx}`}
            blocks={message.blocks}
            chatbotIcon={searchpal}
            role={message.role}
            setChatbotOpen={setChatbotOpen}
            timestamp={message.timestamp}
            expandContent={expandContent}
            shouldShowConfirmChip={message.shouldShowConfirmChip}
            shouldShowViewResultsChip={message.shouldShowViewResultsChip}
            onConfirmFilters={async () => {
              await applyPendingFilters();
            }}
          />
        ))}

        {isGeneratingResponse && (
          <Box alignSelf="flex-start" data-testid="chat-message" maxWidth="70%">
            <Stack direction="row" alignItems="flex-start">
              {searchpal && (
                <img
                  src={searchpal}
                  alt="searchpal"
                  style={{ width: '32px', height: '32px', marginRight: '8px' }}
                />
              )}
              <Card
                sx={(theme) => ({
                  backgroundColor: theme.palette.background.paper,
                  borderRadius: '16px 16px 16px 4px',
                  boxShadow: 'none',
                  marginBottom: theme.spacing(4),
                })}
              >
                <DotsLoading />
              </Card>
            </Stack>
          </Box>
        )}
        <Box ref={messagesEndRef} />
      </Stack>
    </Box>
  );
}
